import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import LedgerTable from '../../../../components/Tables/Montgomery/MachineLedgers';

import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome, FaFileExcel } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

// 5.7 OEM GENERAL MAINTENANCE RECOMMENDATIONS
// 5.7.1 3M
// 5.7.2 Allen Bradley
// 5.7.3 FANUC
// 5.7.4 GRACO
// 5.7.5 LARCO
// 5.7.6 SICK
// 5.7.7 SMC
// 5.7.8 Teledyne

const SIMaintenanceOEM = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Machine Ledgers</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Machine Ledgers" className="mb-3">
								<Tab eventKey="Machine Ledgers" title="Machine Ledgers">
									<h2>MACHINE LEDGERS</h2>
									<p>Maintenance information for the OEM equipment can be found in the documentation provided by the equipment manufacturer. The following table list the document and lists the section and where the maintenance information can be located.</p>
									<LedgerTable tablesorter={true} />
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenanceOEM;
